import Skill from './Skill';

export default function Hero () {
    return (
        <div className='hero-container m-4'>
          <h1 className='font-bold animate-fade-in-1'>Hello I'm<br /> Domenic Marchese</h1>
          <p className='font-mono mt-5 text-xl font-bold animate-fade-in-2'>
            I am a Lead Software Engineer at iManage, where I help design and implement complex features to help secure clients and ensure existing clients are happy with our product.
            I'm passionate about working on cool projects and ensuring the best possible user experience. In my free time I like working on my personal mobile apps and doing puzzles!
          </p>
          <div className='mt-2 flex space-x-4 flex-wrap justify-center animate-fade-in-3'>
            <Skill icon={'react'} skill={'React'} />
            <Skill icon={'ember'} skill={'EmberJS'} />
            <Skill icon={'angular'} skill={'Angular'} />
            <Skill icon={'square-js'} skill={'Javascript'} />
            <Skill icon={'html5'} skill={'HTML'} />
            <Skill icon={'python'} skill={'Python'} />
            <Skill icon={'react'} skill={'React Native'} />
          </div>
        </div>
      );
}